<template>
  <div class="col-md-3">
    <form-group-cpf
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required, cpf: true }"
    />
  </div>
</template>

<script>
import CPF from "cpf";

export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-cpf",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  created() {
    this.$validator.extend("cpf", {
      getMessage: "O CPF informado é inválido",
      validate: value => {
        return CPF.isValid(value);
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Cpf.vue